export default defineNuxtPlugin((nuxtApp) => {
  // event to indicate when a page has finished loading, useful when optimpzly or other script needs to know when the user changes pages.
  nuxtApp.hook("page:finish", () => {
    const loadEvent = new Event("asuo-page-load");
    window.dispatchEvent(loadEvent);
  });
});
